export type ServiceItem = {
  id: number;
  title: string;
  description: string;
  category: string;
  link: string;
  icon?: "mosque" | "land" | "search" | "maintenance" | "employee" | "generic";
  /** Extra phrases (AR/EN) used only for /services?q= matching */
  searchKeywords?: string[];
};

export const getServicesData = (t: (key: string) => string): ServiceItem[] => [
  {
    id: 101,
    title: t('serviceMosqueSearch'),
    description: t('serviceMosqueSearchDesc'),
    category: t('categoryElectronicServices'),
    link: "/service/mosque-search",
    icon: "search",
    searchKeywords: [
      "مسجد",
      "مساجد",
      "بحث",
      "البحث",
      "mosque",
      "mosques",
      "search",
      "find",
    ],
  },
  {
    id: 102,
    title: t('serviceAvailableLands'),
    description: t('serviceAvailableLandsDesc'),
    category: t('categoryElectronicServices'),
    link: "/service/available-lands",
    icon: "land",
    searchKeywords: [
      "أرض",
      "أراضي",
      "بناء",
      "مسجد",
      "land",
      "lands",
      "available",
      "building",
      "plot",
    ],
  },
  {
    id: 103,
    title: t('serviceMosqueContribution'),
    description: t('serviceMosqueContributionDesc'),
    category: t('categoryElectronicServices'),
    link: "/service/mosque-contribution",
    icon: "maintenance",
    searchKeywords: [
      "صيانة",
      "فرص",
      "عقود",
      "مسجد",
      "maintenance",
      "contribution",
      "donation",
      "opportunities",
      "contract",
    ],
  },
];


